import React from 'react'

import table from '#base/assets/img/chart_placeholders/table.png'
import line from '#base/assets/img/chart_placeholders/line.png'
import map from '#base/assets/img/chart_placeholders/map.png'
import forest from '#base/assets/img/chart_placeholders/forest.png'
import sankey from '#base/assets/img/chart_placeholders/sankey.png'
import bar from '#base/assets/img/chart_placeholders/bar.png'
import sunburst from '#base/assets/img/chart_placeholders/sunburst.png'

const placeholders = {
  table,
  line,
  map,
  forest,
  sankey,
  bar,
  sunburst
}

/**
 * Temporary placeholder for chart blocks until we can render charts with sample data
 */
export const PlaceholderBlock = function ({ blockType }) {
  return <img src={placeholders[blockType]} width={1024} />
}
